


















import { Button, ButtonMode, ButtonSize } from '@alpha/ink'
import { Vue, Component, Prop } from 'vue-property-decorator'

export interface AjaxButtonType extends Vue{
  finish() : void
}

@Component({
  components: {
    Button
  }
})

export default class AjaxButton extends Vue {
  @Prop({ default: '' }) readonly classes!: string
  @Prop({ default: '' }) readonly text!: string
  @Prop({ default: false }) readonly disabled!: boolean
  @Prop({ default: '' }) readonly imgSrc!: string
  @Prop({ default: '' }) readonly imgClass!: string
  @Prop() readonly mode!: ButtonMode
  @Prop() readonly size!: ButtonSize

  processing = false

  buttonClick () {
    if (!this.disabled && !this.processing) {
      this.processing = true
      this.$emit('click', this)
    }
  }

  finish () {
    this.processing = false
  }
}
